import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { Locales } from '../../store/setLocales';
import { LanguageSwitcherContainer, LanguageSwitcherButton, LanguageSwitcherDropdown } from './styles';
import Utils from '../../utils';
import { StoreState } from '../../reducers';
import { DropdownMenuList, DropdownMenuListItem } from '../../components/SimpleDropdownMenu/styles';
import { setUserLocale } from '../App/actions';
import IndexedDBManager from '../../utils/indexedDB/manager';

interface LanguageSwitcherProps {
	language: string;
	dispatch: Dispatch<StoreState>;
}

interface LanguageSwitcherState {
	isLanguageMenuOpen: boolean;
}

class LanguageSwitcher extends React.Component<LanguageSwitcherProps, LanguageSwitcherState> {
	constructor(props: LanguageSwitcherProps) {
		super(props);
		this.state = {
			isLanguageMenuOpen: false,
		};

		this.toggleLanguageMenu = this.toggleLanguageMenu.bind(this);
		this.setLanguage = this.setLanguage.bind(this);
	}

	componentDidMount() {
		this.restoreStoredLocale().then();
	}

	toggleLanguageMenu(): void {
		const { isLanguageMenuOpen } = this.state;
		this.setState({ isLanguageMenuOpen: !isLanguageMenuOpen });
	}

	openLanguageMenu(): void {
		this.setState({ isLanguageMenuOpen: true });
	}

	closeLanguageMenu(): void {
		this.setState({ isLanguageMenuOpen: false });
	}

	setLanguage(locale: string, setLocalStorage: boolean = true): void {
		const { dispatch } = this.props;
		dispatch(setUserLocale(locale, false, setLocalStorage));
	}

	renderLanguageList() {
		return Object.keys(Locales).map(locale => {
			return (
				<DropdownMenuListItem
					key={locale}
					onClick={() => this.setLanguage(locale)}
				>
					{Locales[locale]}
				</DropdownMenuListItem>
			);
		});
	}

	get isLanguageMenuOpen(): boolean {
		return this.state.isLanguageMenuOpen;
	}

	render() {
		const { isLanguageMenuOpen } = this;
		const { language } = this.props;

		return (
			<LanguageSwitcherContainer
				onClick={() => this.toggleLanguageMenu()}
				isOpen={isLanguageMenuOpen}
			>
				<LanguageSwitcherButton>
					{Locales[language]}
					{Utils.getSvgIcon('iconset_down')}
				</LanguageSwitcherButton>
				<LanguageSwitcherDropdown>
					<DropdownMenuList>
						{this.renderLanguageList()}
					</DropdownMenuList>
				</LanguageSwitcherDropdown>
			</LanguageSwitcherContainer>
			);
	}

	private async restoreStoredLocale(): Promise<void> {
		const storedUserLocale = await IndexedDBManager.getUserLocale(false);

		if (storedUserLocale) {
			this.setLanguage(storedUserLocale, false);
		}
	}
}

const mapStateToProps = (state: StoreState) => {
	const { locale } = state.i18n;
	return { language: locale };
};

export default connect(mapStateToProps)(LanguageSwitcher);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/LanguageSwitcher/index.tsx